import {
  CAPTAIN_OPTION_1_INCLUDED_IN_PRICE,
  CAPTAIN_OPTION_2_INDEPENDENT_CAPTAIN,
  CAPTAIN_OPTION_4_NOT_INCLUDED_IN_PRICE,
  CAPTAIN_OPTION_KEYS,
} from 'src/common/constants';

const {
  PROVIDED,
  ARRANGED_SEPARATELY,
  NOT_PROVIDED,
} = CAPTAIN_OPTION_KEYS;

const getTripCaptainOption = (captainOption: string): number | undefined => {
  if (captainOption === PROVIDED) {
    return CAPTAIN_OPTION_1_INCLUDED_IN_PRICE;
  }
  if (captainOption === ARRANGED_SEPARATELY) {
    return CAPTAIN_OPTION_2_INDEPENDENT_CAPTAIN;
  }
  if (captainOption === NOT_PROVIDED) {
    return CAPTAIN_OPTION_4_NOT_INCLUDED_IN_PRICE;
  }
  return undefined;
};

export default getTripCaptainOption;
